import gql from "graphql-tag";

const notificationFieldsFragment = gql`
  fragment NotificationFields on UserNotification {
    id
    type
    createdAt
    data {
      ... on AchievementUserNotificationData {
        __typename
        balance
        type
      }
      ... on LeaderboardUserNotificationData {
        timeFrame
        endDate
        leaderboardId
        rank
        score
        leaderboardType
      }
      ... on TournamentUserNotificationData {
        __typename
        rank
        gameId
        tournamentId
      }
      ... on FollowUserNotificationData {
        __typename
        followerUser {
          id
          username
          xp
          avatar
        }
      }
      ... on BattleUserNotificationData {
        host {
          avatar
          id
          username
        }
        opponent {
          avatar
          id
          username
        }
        gameId
        matchId
      }
      ... on SubscriptionActivationNotificationData {
        __typename
        earnedTags
      }
      ... on SubscriptionBonusEligibleNotificationData {
        __typename
        bonusDays
        earnedTags
      }
    }
  }
`;

export const getUserNotificationsGQL = gql`
  query User($userId: UUID!, $product: String!) {
    user(id: $userId) {
      id
      notifications(input: { product: $product }) {
        ...NotificationFields
      }
    }
  }
  ${notificationFieldsFragment}
`;

export const meNotificationsGQL = gql`
  query MeNotifications($product: String!) {
    me {
      id
      notifications(input: { product: $product }) {
        ...NotificationFields
      }
    }
  }
  ${notificationFieldsFragment}
`;
